import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import ProjectSecTwo from '../components/sections/ProjectSecTwo';

const Portfolio = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.portfolio.title" subtitleKey="sections.breadcrumb.portfolio.subtitle" />
        <ProjectSecTwo className="space overflow-hidden" />
      <Footer />
    </>
  );
};

export default Portfolio;